<template>
    <div class="list-wrapper">
        <div class="list-header">Список контрагентов</div>
        
        <div class="list-toolbar">
            <div><input v-model="searchString" type="text" placeholder="поиск"/></div>
        </div>
        <ul class="list-table">
            <li v-for="item in filteredList" :key="item.id">
                <span class="item-type">{{item.type}}</span>
                <span class="item-title">{{item.title}}</span>
                <span class="item-actions" >
                    <button @click="editItem(item.id)" title="Редактировать">
                        <i class="fa fa-edit"></i>
                    </button>
                    <button @click="deleteItem(item.id)" title="Удалить">
                        <i class="fa fa-times"></i>
                    </button>
                </span>
            </li>
        </ul>
        <div class="list-footer">
            <button>Добавить</button>
        </div>
    </div>
</template>


<script>
//<custom-element v-bind:whatever="[...array]"></custom-element>
import searchMixin from '@/components/mixins/listFilterByTitle';
export default {
    name: 'company-list',
    template: '<company-list />',
    props: {
        listType:{type: String, default: ''}
    },
    mixins: [searchMixin],
    data (){
        return {
            searchString: '',
            filterType: '',
            items: [
                {id: 1, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 1', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 2, type: 'client', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 2', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 3, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 3', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 4, type: 'client', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 4', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 5, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 5', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 6, type: 'client', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 6', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 7, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 8, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 9, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 10, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 11, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 12, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 13, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 14, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
                {id: 15, type: 'worker', title: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. 7', address: '',  inn: '000', kpp:'000', phone: '000'},
            ]
        }
    },
    
    computed:{
        filteredByType(){
            let listType = this.listType;
            if (this.listType === '') { return this.items }
            return this.items.filter( function(item) {
                    return item.type === listType;
            })
        },
        
        filteredList(){
            let searchString = this.searchString;
            if (this.searchString === '') {return this.filteredByType}
            return this.filteredByType.filter( function(item) {
                return item.title.toLowerCase().includes(searchString.toLowerCase());
            })
        }
    },

    methods:{
        setListType(listType){
            this.filterType = listType
        },

        editItem(itemId){

        },
        
        updateItem(){

        },

        deleteItem(itemId){
            console.log('deleting: ' + itemId);
        }
    },

    created(){
        //setListType(this.params.listType);
    },

    mounted(){
        

    }
}
</script>

<style lang="scss">

$list-odd-row-color: rgba(137, 160, 183, 0.1);


.list-wrapper{
    display: flex;
    flex-flow: column;
    width: 100%;
    margin: 1rem;

    border-radius: 2px;
}

.list-header{
    background: #eee;
    border-bottom: 1px solid #ddd;
    font-size: 1.3rem;
    text-shadow: #fff 0 1px 0;
}

.list-toolbar{
    display: flex;
    background: #eee;
    border-bottom: 1px solid #ddd;
    flex-flow: row;
}

.list-toolbar input{
    background-color: #fff;
    background-position: right 8px center;
    background-repeat: no-repeat;
    border: 1px solid #d1d5da;
    border-radius: 2px;
    box-shadow: inset 0 1px 2px rgba(27,31,35,.075);
    color: #24292e;
    outline: none;
    padding: 6px 8px;
    vertical-align: middle;
}


.list-table{
    display: flex; 
    flex-wrap: nowrap;
    flex-direction: column;
    width: 100%;    
    border: 1px solid #ccc;
}

.list-table li{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px dotted #ccc;

}

.list-table > li:nth-of-type(odd) {
    background-color: $list-odd-row-color;
}

.list-table > li:last-child {
    border-bottom: none;
}

.list-table li span{
    padding: .3rem 1rem;    
}

.list-table li .item-title{
    flex-basis: 4rem;
    flex-grow: 1;
}

.list-table  li:hover .item-actions{
    visibility: visible;
}
.list-table .item-actions{
    visibility: hidden;
}
.list-table .item-actions button{
    cursor: pointer
}
</style>
